import type { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import type { CommitmentTemplateRequest } from '#components/product-finance/client';

import type { ManagedCommitment } from './CommitmentManagement';
import { assertNever } from './management-shared';

export type RecurrenceFrequency = 'weekly' | 'monthly' | 'yearly';

export function createRecurrenceRequest(
  frequency: RecurrenceFrequency,
  dayOfWeek: string,
  dayOfMonth: string,
  month: string,
): CommitmentTemplateRequest['recurrence'] {
  switch (frequency) {
    case 'weekly':
      return { frequency, dayOfWeek: Number(dayOfWeek) };
    case 'monthly':
      return { frequency, dayOfMonth: Number(dayOfMonth) };
    case 'yearly':
      return {
        frequency,
        month: Number(month),
        dayOfMonth: Number(dayOfMonth),
      };
    default:
      return assertNever(frequency);
  }
}

export function formatRecurrence(
  recurrence: ManagedCommitment['template']['recurrence'],
): ReactNode {
  switch (recurrence.frequency) {
    case 'weekly':
      return <Trans>Weekly on day {{ day: recurrence.dayOfWeek }}</Trans>;
    case 'monthly':
      return <Trans>Monthly on day {{ day: recurrence.dayOfMonth }}</Trans>;
    case 'yearly':
      return (
        <Trans>
          Yearly on {{ month: recurrence.month }}/
          {{ day: recurrence.dayOfMonth }}
        </Trans>
      );
    default:
      return assertNever(recurrence);
  }
}

export function readFrequency(value: string): RecurrenceFrequency {
  if (value === 'weekly' || value === 'monthly' || value === 'yearly') {
    return value;
  }
  throw new Error('Unsupported recurrence frequency.');
}
